import "./_layout.scss";

import {ReactElement, useContext} from "react";
import {Link} from "react-router-dom";

import logo from "@/assets/logo_cofaq_bleu.png";
import NavigationElement from "@/components/Navigation/Navigation";
import {GlobalContext} from "@/context/global";
import {navItem} from "@/types/navigation";

function Header(): ReactElement {
  const {navigation} = useContext(GlobalContext);
  return (
    <>
      <header id="header">
        <div className="header">
          <Link to="/">
            <img
              src={logo}
              alt="logo Cofaq"
              className="header-logo"
              loading="lazy"
            />
          </Link>
          <div className="header-content">
            <input
              type="text"
              className="header-input"
              placeholder="Rechercher"
            />

            <NavigationElement navItems={navigation as navItem[]} />
          </div>

          <div className="header-profil"></div>
        </div>
        <input
          type="text"
          className="header-input"
          id="responsiveInput"
          placeholder="Rechercher"
        />
      </header>
    </>
  );
}

export default Header;
